import React from 'react';   
import Router from './Router.js'

export default class App extends React.Component {

    /*
    componentDidMount() {
        const script = document.createElement("script");
        script.src = "/js/jquery-3.4.1.min.js";
        document.head.appendChild(script);

        const script2 = document.createElement("script");
        script2.src = "/js/bootstrap/popper.min.js";
        document.head.appendChild(script2);

        const script3 = document.createElement("script");
        script3.src = "/js/bootstrap/bootstrap.min.js";
        document.head.appendChild(script3);

        const script4 = document.createElement("script");
        script4.src = "/js/jquery.fancybox.js";
        document.head.appendChild(script4);

        const script5 = document.createElement("script");
        script5.src = "/js/swiper.js";
        document.head.appendChild(script5);

        const script6 = document.createElement("script");
        script6.src = "/js/aos.js";
        document.head.appendChild(script6);

        const script7 = document.createElement("script");
        script7.src = "/js/custom.js";
        document.head.appendChild(script7);
    }

     */

    render() {
        return <Router/>
    }
}